// import components
import { Box } from '@mui/material';

// import external libraries
import { memo } from 'react';

// import styles
import { cellWrapperSx, cellBadgeSx } from './PrescriptionRuleCell.styles';

export interface PrescriptionRuleCellValue {
  frequency: number;
  cellColSpan: number;
  totalWeeks?: number;
}

interface PrescriptionRuleCellProps {
  value?: PrescriptionRuleCellValue | null;
}

const isPrescriptionRuleCellValue = (
  value: unknown
): value is PrescriptionRuleCellValue =>
  typeof value === 'object' &&
  value !== null &&
  'frequency' in value &&
  'cellColSpan' in value;

const PrescriptionRuleCell = memo(({ value }: PrescriptionRuleCellProps) => {
  if (!value || !isPrescriptionRuleCellValue(value)) return null;

  return (
    <Box sx={cellWrapperSx}>
      <Box sx={cellBadgeSx}>
        {value.totalWeeks
          ? `${value.frequency} (${value.totalWeeks}w)`
          : value.frequency}
      </Box>
    </Box>
  );
});

export default PrescriptionRuleCell;
